import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-value" }
const _hoisted_2 = { class: "filter-domain-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "filter-card" }, {
    content: _withCtx(() => [
      _createVNode("div", {
        class: ["p-d-flex p-flex-column p-ai-center filter-container p-p-0", { 'functions-filter-card-active': _ctx.filter.active }],
        style: { 'background-image': 'url(' + require('@/assets/images/functionCatalog/' + _ctx.filter.valueDescription + '.png') + ')' },
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selected', _ctx.filter)))
      }, [
        _createVNode("span", _hoisted_1, _toDisplayString(_ctx.filter.valueCd), 1),
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.filter.domainName), 1)
      ], 6)
    ]),
    _: 1
  }))
}